import React from 'react';

const faqs = [
  {
    question: "How does hiiroo's AI application kit work?",
    answer: "Our AI-powered platform analyzes your resume and the job description to create a complete application package. It generates an optimized resume, tailored cover letter, and finds matching job opportunities - all personalized to your specific skills and the role requirements."
  },
  {
    question: "What's included in the application kit?",
    answer: "Each application kit includes three key components: 1) An ATS-optimized resume tailored to the specific job, 2) A personalized cover letter that highlights your relevant experience, and 3) AI-matched job recommendations from top job boards."
  },
  {
    question: "How many application kits can I generate?",
    answer: "New users get 3 free application kits. After that, you can purchase additional credits or subscribe to our premium plans for unlimited generations and additional features to help you in your job search."
  },
  {
    question: "Can I edit the generated documents?",
    answer: "Yes, you have full control to edit both your optimized resume and cover letter. Our AI creates professional drafts that you can customize to match your personal style and preferences."
  },
  {
    question: "How does the job matching feature work?",
    answer: "Our AI analyzes your skills and experience against millions of job postings to find the most relevant opportunities. It considers factors like role requirements, company culture, and your career goals to suggest positions where you'll have the highest chance of success."
  },
  {
    question: "What file formats do you support?",
    answer: "We support all major file formats including PDF, DOC, DOCX, and TXT for both uploading your existing resume and downloading your optimized application documents."
  },
  {
    question: "Is my information secure?",
    answer: "Yes, we take data security seriously. All your documents and personal information are encrypted and stored securely. We never share your information with third parties."
  },
  {
    question: "How effective are hiiroo's application kits?",
    answer: "Our users report a significant increase in interview invitations, with many receiving responses within days of applying. The AI-optimized documents are designed to pass ATS systems and impress human recruiters."
  }
];

export function FAQ() {
  const [openIndex, setOpenIndex] = React.useState<number | null>(null);

  return (
    <div className="max-w-4xl mx-auto px-4 py-12">
      <h1 className="text-3xl font-bold mb-8">Frequently Asked Questions</h1>
      
      <div className="space-y-6">
        {faqs.map((faq, index) => (
          <div key={index} className="bg-white p-6 rounded-lg shadow-sm">
            <button
              onClick={() => setOpenIndex(openIndex === index ? null : index)}
              className="w-full flex items-center justify-between text-left"
            >
              <h3 className="font-semibold text-lg">{faq.question}</h3>
              <span className="text-primary ml-4">
                {openIndex === index ? '−' : '+'}
              </span>
            </button>
            
            {openIndex === index && (
              <div className="mt-4 text-gray-600">
                {faq.answer}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}